var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHyPetRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 305,
    viewBox: "0 0 238 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3651_2474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.66 58.51V58.0031L13.1531 58.01L11.47 58.0331V53.1965L12.4437 53.1698L12.93 53.1565V52.67V51.2V50.7H12.43H11.4858L11.599 47.0787L12.2773 47.2961L12.93 47.5054V46.82V44.62V44.184L12.498 44.1247L11.62 44.004V39.8881L13.1233 39.9987L13.66 40.0381V39.5V38.04V37.6123L13.2375 37.546L11.62 37.2923V30.5H18.51V37.54H15.35H14.7285L14.8616 38.147L15.1816 39.607L15.2677 40H15.67H18.508L18.4919 44.12H15.35H14.8247L14.8506 44.6446L14.9606 46.8746L14.984 47.35H15.46H18.83V50.75H16.08H15.58V51.25V52.88V53.38H16.08H18.51V58.01H17.02H16.52V58.51V68.25H13.66V58.51Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 290.51V69.25H177.17V290.51H0.5Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.17 69.3485L204.22 74.0577V76.2258L180.663 73.3752L178.17 72.9398V69.3485Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.17 290.076V73.9278L204.218 77.2307L203.491 273.202L178.17 290.076Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.17 72.9757L204.22 76.1922V76.2333L178.17 73.4212V72.9757Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.16 74.5996H12.76V285.83H167.16V74.5996Z",
    fill: "#6A5DFF",
    stroke: "#1C2145",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.76 160.75H129.04V220.61H12.76",
    fill: "#6A5DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.76 160.75H129.04V220.61H12.76",
    stroke: "#1C2145",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.04 74.5996V285.83",
    stroke: "#1C2145",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4 299.28V297.36H35.32V299.28H33.4Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4 302.94V301.02H35.32V302.94H33.4Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4801 296.73V292.61H38.2501V296.73H30.4801Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4 299.28V297.36H35.32V299.28H33.4Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6101 300.29H39.1101C40.2478 300.29 41.17 301.212 41.17 302.35C41.17 303.488 40.2478 304.41 39.1101 304.41H29.6101C28.4723 304.41 27.55 303.488 27.55 302.35C27.55 301.212 28.4723 300.29 29.6101 300.29Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.34 296.73V292.61H150.11V296.73H142.34Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.26 299.28V297.36H147.18V299.28H145.26Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.48 300.29H150.98C152.118 300.29 153.04 301.212 153.04 302.35C153.04 303.488 152.118 304.41 150.98 304.41H141.48C140.342 304.41 139.42 303.488 139.42 302.35C139.42 301.212 140.342 300.29 141.48 300.29Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.36 175V172.34H61.65V175H25.36Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.36 179.8V177.14H61.65V179.8H25.36Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.36 184.61V181.95H61.65V184.61H25.36Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.36 189.41V186.75H61.65V189.41H25.36Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.36 194.22V191.56H61.65V194.22H25.36Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.36 199.019V196.359H61.65V199.019H25.36Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.36 203.83V201.17H61.65V203.83H25.36Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.36 208.63V205.97H61.65V208.63H25.36Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66 175V172.34H117.95V175H81.66Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66 179.8V177.14H117.95V179.8H81.66Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66 184.61V181.95H117.95V184.61H81.66Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66 189.41V186.75H117.95V189.41H81.66Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66 194.22V191.56H117.95V194.22H81.66Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66 199.019V196.359H117.95V199.019H81.66Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66 203.83V201.17H117.95V203.83H81.66Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66 208.63V205.97H117.95V208.63H81.66Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66 238.61V235.95H117.95V238.61H81.66Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66 243.41V240.75H117.95V243.41H81.66Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66 248.221V245.561H117.95V248.221H81.66Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66 253.02V250.36H117.95V253.02H81.66Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66 257.83V255.17H117.95V257.83H81.66Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66 262.63V259.97H117.95V262.63H81.66Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66 267.44V264.78H117.95V267.44H81.66Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66 272.24V269.58H117.95V272.24H81.66Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.36 238.61V235.95H61.65V238.61H25.36Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.36 243.41V240.75H61.65V243.41H25.36Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.36 248.221V245.561H61.65V248.221H25.36Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.36 253.02V250.36H61.65V253.02H25.36Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.36 257.83V255.17H61.65V257.83H25.36Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.36 262.63V259.97H61.65V262.63H25.36Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.36 267.44V264.78H61.65V267.44H25.36Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.36 272.24V269.58H61.65V272.24H25.36Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.34 112.98C185.34 112.98 210.93 107.13 203.62 171.47C196.31 235.81 186.8 254.82 223.36 232.89C232.13 227.04 234.69 224.77 234.69 224.77",
    fill: "#6A5DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.34 112.98C185.34 112.98 210.93 107.13 203.62 171.47C196.31 235.81 186.8 254.82 223.36 232.89C232.13 227.04 234.69 224.77 234.69 224.77",
    stroke: "#1C2145",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.15 134.12C183.15 134.12 195.85 131.22 192.22 163.15C188.59 195.08 183.87 204.52 202.02 193.63C206.37 190.73 207.64 189.6 207.64 189.6",
    fill: "#6A5DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.15 134.12C183.15 134.12 195.85 131.22 192.22 163.15C188.59 195.08 183.87 204.52 202.02 193.63C206.37 190.73 207.64 189.6 207.64 189.6",
    stroke: "#1C2145",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.03 112.98C187.03 114.131 186.796 115.149 186.441 115.861C186.071 116.603 185.653 116.87 185.34 116.87C185.027 116.87 184.609 116.603 184.239 115.861C183.884 115.149 183.65 114.131 183.65 112.98C183.65 111.828 183.884 110.81 184.239 110.099C184.609 109.357 185.027 109.09 185.34 109.09C185.653 109.09 186.071 109.357 186.441 110.099C186.796 110.81 187.03 111.828 187.03 112.98Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.74 133.82C183.74 134.163 183.67 134.448 183.579 134.629C183.552 134.683 183.529 134.719 183.51 134.743C183.491 134.719 183.468 134.683 183.441 134.629C183.35 134.448 183.28 134.163 183.28 133.82C183.28 133.478 183.35 133.193 183.441 133.012C183.468 132.958 183.491 132.922 183.51 132.898C183.529 132.922 183.552 132.958 183.579 133.012C183.67 133.193 183.74 133.478 183.74 133.82ZM183.464 134.788C183.464 134.788 183.465 134.788 183.467 134.787C183.465 134.788 183.464 134.788 183.464 134.788ZM183.553 134.787C183.555 134.788 183.556 134.788 183.556 134.788C183.556 134.788 183.555 134.788 183.553 134.787ZM183.556 132.853C183.556 132.853 183.555 132.853 183.553 132.854C183.555 132.853 183.556 132.852 183.556 132.853ZM183.467 132.854C183.465 132.853 183.464 132.853 183.464 132.853C183.464 132.852 183.465 132.853 183.467 132.854Z",
    fill: "#6A5DFF",
    stroke: "#1C2145"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    width: 75,
    height: 30,
    rx: 15,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.148 19L66.3 15.736H65.508V19H63.828V10.624H66.972C67.62 10.624 68.172 10.74 68.628 10.972C69.084 11.196 69.424 11.504 69.648 11.896C69.88 12.28 69.996 12.712 69.996 13.192C69.996 13.744 69.836 14.244 69.516 14.692C69.196 15.132 68.72 15.436 68.088 15.604L70.092 19H68.148ZM65.508 14.476H66.912C67.368 14.476 67.708 14.368 67.932 14.152C68.156 13.928 68.268 13.62 68.268 13.228C68.268 12.844 68.156 12.548 67.932 12.34C67.708 12.124 67.368 12.016 66.912 12.016H65.508V14.476ZM74.4675 19.108C73.8275 19.108 73.2515 18.968 72.7395 18.688C72.2275 18.4 71.8235 17.996 71.5275 17.476C71.2395 16.956 71.0955 16.356 71.0955 15.676C71.0955 14.996 71.2435 14.396 71.5395 13.876C71.8435 13.356 72.2555 12.956 72.7755 12.676C73.2955 12.388 73.8755 12.244 74.5155 12.244C75.1555 12.244 75.7355 12.388 76.2555 12.676C76.7755 12.956 77.1835 13.356 77.4795 13.876C77.7835 14.396 77.9355 14.996 77.9355 15.676C77.9355 16.356 77.7795 16.956 77.4675 17.476C77.1635 17.996 76.7475 18.4 76.2195 18.688C75.6995 18.968 75.1155 19.108 74.4675 19.108ZM74.4675 17.644C74.7715 17.644 75.0555 17.572 75.3195 17.428C75.5915 17.276 75.8075 17.052 75.9675 16.756C76.1275 16.46 76.2075 16.1 76.2075 15.676C76.2075 15.044 76.0395 14.56 75.7035 14.224C75.3755 13.88 74.9715 13.708 74.4915 13.708C74.0115 13.708 73.6075 13.88 73.2795 14.224C72.9595 14.56 72.7995 15.044 72.7995 15.676C72.7995 16.308 72.9555 16.796 73.2675 17.14C73.5875 17.476 73.9875 17.644 74.4675 17.644ZM80.8478 13.324C81.0638 13.004 81.3598 12.744 81.7358 12.544C82.1198 12.344 82.5558 12.244 83.0438 12.244C83.6118 12.244 84.1238 12.384 84.5798 12.664C85.0438 12.944 85.4078 13.344 85.6718 13.864C85.9438 14.376 86.0798 14.972 86.0798 15.652C86.0798 16.332 85.9438 16.936 85.6718 17.464C85.4078 17.984 85.0438 18.388 84.5798 18.676C84.1238 18.964 83.6118 19.108 83.0438 19.108C82.5478 19.108 82.1118 19.012 81.7358 18.82C81.3678 18.62 81.0718 18.364 80.8478 18.052V19H79.1678V10.12H80.8478V13.324ZM84.3638 15.652C84.3638 15.252 84.2798 14.908 84.1118 14.62C83.9518 14.324 83.7358 14.1 83.4638 13.948C83.1998 13.796 82.9118 13.72 82.5998 13.72C82.2958 13.72 82.0078 13.8 81.7358 13.96C81.4718 14.112 81.2558 14.336 81.0878 14.632C80.9278 14.928 80.8478 15.276 80.8478 15.676C80.8478 16.076 80.9278 16.424 81.0878 16.72C81.2558 17.016 81.4718 17.244 81.7358 17.404C82.0078 17.556 82.2958 17.632 82.5998 17.632C82.9118 17.632 83.1998 17.552 83.4638 17.392C83.7358 17.232 83.9518 17.004 84.1118 16.708C84.2798 16.412 84.3638 16.06 84.3638 15.652ZM90.2527 19.108C89.6127 19.108 89.0367 18.968 88.5247 18.688C88.0127 18.4 87.6087 17.996 87.3127 17.476C87.0247 16.956 86.8807 16.356 86.8807 15.676C86.8807 14.996 87.0287 14.396 87.3247 13.876C87.6287 13.356 88.0407 12.956 88.5607 12.676C89.0807 12.388 89.6607 12.244 90.3007 12.244C90.9407 12.244 91.5207 12.388 92.0407 12.676C92.5607 12.956 92.9687 13.356 93.2647 13.876C93.5687 14.396 93.7207 14.996 93.7207 15.676C93.7207 16.356 93.5647 16.956 93.2527 17.476C92.9487 17.996 92.5327 18.4 92.0047 18.688C91.4847 18.968 90.9007 19.108 90.2527 19.108ZM90.2527 17.644C90.5567 17.644 90.8407 17.572 91.1047 17.428C91.3767 17.276 91.5927 17.052 91.7527 16.756C91.9127 16.46 91.9927 16.1 91.9927 15.676C91.9927 15.044 91.8247 14.56 91.4887 14.224C91.1607 13.88 90.7567 13.708 90.2767 13.708C89.7967 13.708 89.3927 13.88 89.0647 14.224C88.7447 14.56 88.5847 15.044 88.5847 15.676C88.5847 16.308 88.7407 16.796 89.0527 17.14C89.3727 17.476 89.7727 17.644 90.2527 17.644ZM96.909 13.732V16.948C96.909 17.172 96.961 17.336 97.065 17.44C97.177 17.536 97.361 17.584 97.617 17.584H98.397V19H97.341C95.925 19 95.217 18.312 95.217 16.936V13.732H94.425V12.352H95.217V10.708H96.909V12.352H98.397V13.732H96.909ZM104.121 10.624V15.808C104.121 16.376 104.269 16.812 104.565 17.116C104.861 17.412 105.277 17.56 105.813 17.56C106.357 17.56 106.777 17.412 107.073 17.116C107.369 16.812 107.517 16.376 107.517 15.808V10.624H109.209V15.796C109.209 16.508 109.053 17.112 108.741 17.608C108.437 18.096 108.025 18.464 107.505 18.712C106.993 18.96 106.421 19.084 105.789 19.084C105.165 19.084 104.597 18.96 104.085 18.712C103.581 18.464 103.181 18.096 102.885 17.608C102.589 17.112 102.441 16.508 102.441 15.796V10.624H104.121ZM114.516 12.256C115.308 12.256 115.948 12.508 116.436 13.012C116.924 13.508 117.168 14.204 117.168 15.1V19H115.488V15.328C115.488 14.8 115.356 14.396 115.092 14.116C114.828 13.828 114.468 13.684 114.012 13.684C113.548 13.684 113.18 13.828 112.908 14.116C112.644 14.396 112.512 14.8 112.512 15.328V19H110.832V12.352H112.512V13.18C112.736 12.892 113.02 12.668 113.364 12.508C113.716 12.34 114.1 12.256 114.516 12.256ZM119.618 11.56C119.322 11.56 119.074 11.468 118.874 11.284C118.682 11.092 118.586 10.856 118.586 10.576C118.586 10.296 118.682 10.064 118.874 9.88C119.074 9.688 119.322 9.592 119.618 9.592C119.914 9.592 120.158 9.688 120.35 9.88C120.55 10.064 120.65 10.296 120.65 10.576C120.65 10.856 120.55 11.092 120.35 11.284C120.158 11.468 119.914 11.56 119.618 11.56ZM120.446 12.352V19H118.766V12.352H120.446ZM124.061 13.732V16.948C124.061 17.172 124.113 17.336 124.217 17.44C124.329 17.536 124.513 17.584 124.769 17.584H125.549V19H124.493C123.077 19 122.369 18.312 122.369 16.936V13.732H121.577V12.352H122.369V10.708H124.061V12.352H125.549V13.732H124.061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.049 34.0977L113.975 28.7745L120.122 28.7745L117.049 34.0977Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3651_2474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 238,
    height: 305,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyPetRobot);
export default __webpack_public_path__ + "static/media/HyPET_Robot.ebed9435fc2a0717e3b017d69c0b85e1.svg";
export { ForwardRef as ReactComponent };